import ModalWrapper from '../../common/Modal/ModalWrapper'
import Road from '../../dashboard/road'
import WhatToDoNextCards from '../../dashboard/whatToDoNextCards/whatToDoNextCards'

const WhatToDoNextModal = ({ Objective, subscription = "free", company }) => {
    const data = {
        "investment": [
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    One<span className='c4'>Form</span><br></br>
                    Investor<span className='c4'>Match</span>
                </div>,
                timingButton: '10 Min',
                description: 'Match against our investor database ',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Investment<br></br>
                    Readiness Module
                </div>,
                timingButton: '30 Min',
                description: <>Assesses investment-readiness. Builds Research<span className='c4'>Aid</span> Reports</>,
            },
            ...(['lite', 'pro'].includes(subscription.toLowerCase()) ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Business Audit<br></br>
                    Module
                </div>,
                timingButton: '30 Min',
                description: 'Check your business for strengths and weaknesses',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Data Repository <br></br>
                    Module
                </div>,
                timingButton: '2 Days',
                description: 'Organise your key docs for diligence and beyond',
            }] : []),
            ...(subscription === "Pro" ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Draft Directors’ <br></br>
                    Questionnaires <br></br>
                    Module
                </div>,
                timingButton: '15 Min',
                appStore: true,
                description: 'Investors want to know about you',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Draft Warranty <br></br>
                    Disclosures <br></br>
                    Module
                </div>,
                timingButton: '1 Day',
                appStore: true,
                description: 'Investor want to know details of any problems in your business',
            }] : []),
        ],
        "growth": [
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Growth Readiness<br></br>
                    Module
                </div>,
                timingButton: '10 Min',
                description: 'Check your growth readiness',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Loan Readiness<br></br>
                    Module
                </div>,
                timingButton: '30 Min',
                description: 'Loan readiness checklist for application to 140 lenders',
            },
            ...(['lite', 'pro'].includes(subscription.toLowerCase()) ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Business Audit<br></br>
                    Module
                </div>,
                timingButton: '30 Min',
                description: 'Check your business for strengths and weaknesses',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Data Repository <br></br>
                    Module
                </div>,
                timingButton: '2 Days',
                description: 'Organise your key docs for diligence and beyond',
            }] : []),
            ...(subscription === "Pro" ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Healthboost  <br></br>
                    Modules x20
                </div>,
                timingButton: '30 Min',
                appStore: true,
                description: 'Complete modules to systematically increase business value',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Partner Value<br></br>
                    Creation Modules
                </div>,
                timingButton: '30 Min',
                appStore: true,
                description: '3rd party modules to add further value to your business',
            }] : []),
        ],
        "exit": [
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Exit Readiness <br></br>
                    Module
                </div>,
                timingButton: '10 Min',
                description: 'Check your exit readiness',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Sale Readiness <br></br>
                    Module
                </div>,
                timingButton: '30 Min',
                description: 'Enhance your value and speed of sale',
            },
            ...(['lite', 'pro'].includes(subscription.toLowerCase()) ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Business Audit<br></br>
                    Module
                </div>,
                timingButton: '30 Min',
                description: 'Check your business for strengths and weaknesses',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Data Repository <br></br>
                    Module
                </div>,
                timingButton: '2 Days',
                description: 'Organise your key docs for diligence and beyond',
            }] : []),
            ...(subscription === "Pro" ? [{
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Draft Directors’ <br></br>
                    Questionnaires <br></br>
                    Module
                </div>,
                timingButton: '15 Min',
                appStore: true,
                description: 'Investors want to know about you',
            },
            {
                title: <div className='p2rem mt0-5rem w100 fs12px c15 fw600'>
                    Draft Warranty <br></br>
                    Disclosures <br></br>
                    Module
                </div>,
                timingButton: '1 Day',
                appStore: true,
                description: 'Investor want to know details of any problems in your business',
            }] : []),
        ]
    }

    const cardsLength = data[Objective] ? data[Objective].length : 0;

    return (
        <ModalWrapper
            modalType='whatToDoNextModal'
            modalCardClasses={`py3rem ${cardsLength === 2 ? 'maw1000px' : cardsLength === 4 ? 'maw1200px' : 'maw1500px'} `}
        >
            <div className='df fdc aic jcc br20px p3rem' style={{ background: '#637DF833' }}>
                <h2 className='c15 fs2rem mb5rem'>Suggested Module Completion Order</h2>
                <div className='whatToDoNextModalWrapper'>
                    <Road company={company} title={subscription} upgradeToPro={subscription !== "Pro"} />
                    <div className={`df aic jcc pr`} style={{ top: '-70px', left: cardsLength === 2 ? '-30px' : cardsLength === 4 ? '-30px' : '0px', width: cardsLength === 2 ? "100%" : '85%' }}>
                        {
                            data[Objective].map((item, index) => (
                                <WhatToDoNextCards
                                    lengthCards={cardsLength}
                                    key={index}
                                    count={index + 1}
                                    title={item.title}
                                    timingButton={item.timingButton}
                                    description={item.description}
                                    appStore={item.appStore}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>

        </ModalWrapper>
    )
}

export default WhatToDoNextModal